import { Box, Button, Card, Collapse, Stack, SvgIcon } from '@mui/material'
import { useState } from 'react'
import * as R from 'remeda'
import { routes } from '../routes'
import { buttonStyles } from './styles'
import { CustomNavLink } from '~/features/sidebar/CustomNavLink'
import { IconCaretDownFilled } from '@tabler/icons-react'
import { SystemActions } from './SystemActions'
import { canAccessEntry, useRole } from '~/features/auth/useRole'
import { RoleErrorState } from './RoleErrorState'

const routeValues = R.values(routes).filter((route) => route.inSidebar)

export const Sidebar = () => {
  const [expand, setExpand] = useState<string | null>(null)
  const { role, isError, refetch } = useRole()
  // Without a role every entry would be hidden, so show the error state instead
  const visibleRoutes = isError ? [] : routeValues

  return (
    <Stack sx={{ backgroundColor: 'background.default' }} component={Card} elevation={0} flex={1}>
      <Stack flex={1} py={2} gap={4} sx={{ overflow: 'hidden' }}>
        <Stack>
          <Box
            component="img"
            src="/wollem_logo.png"
            sx={{ width: 80, height: ' auto', alignSelf: 'center' }}
          />
        </Stack>
        <Stack sx={{ overflow: 'auto', flex: 1, px: 2, gap: 1 }}>
          {isError ? <RoleErrorState onRetry={() => refetch()} /> : null}
          {visibleRoutes.map((entry) => {
            const { route, label, Icon, menu, key } = entry
            const isExpanded = expand === key

            if (menu) {
              const visibleItems = R.values(menu).filter((item) => canAccessEntry(role, item))
              if (visibleItems.length === 0) return null

              return (
                <Stack key={key} gap={1}>
                  <Button
                    endIcon={
                      <SvgIcon
                        sx={{
                          width: 16,
                          height: 16,
                          transform: `rotate(${isExpanded ? 180 : 0}deg)`,
                          transition: (t) =>
                            t.transitions.create(['transform'], {
                              duration: t.transitions.duration.short,
                            }),
                        }}
                      >
                        <IconCaretDownFilled />
                      </SvgIcon>
                    }
                    onClick={() => setExpand((prev) => (prev === key ? null : key))}
                    sx={buttonStyles}
                  >
                    {label}
                  </Button>
                  <Collapse in={isExpanded}>
                    <Stack ml={2} gap={1}>
                      {visibleItems.map(({ route: MenuItemRoute, label, Icon: MenuItemIcon }) => {
                        return (
                          <Button
                            key={MenuItemRoute}
                            endIcon={MenuItemIcon}
                            component={CustomNavLink}
                            to={MenuItemRoute}
                            activeClassName={({ isActive }) => (isActive ? 'active' : '')}
                            sx={buttonStyles}
                          >
                            {label}
                          </Button>
                        )
                      })}
                    </Stack>
                  </Collapse>
                </Stack>
              )
            }

            if (!canAccessEntry(role, entry)) return null

            return (
              <Stack key={key} gap={1}>
                <Button
                  component={CustomNavLink}
                  to={route}
                  endIcon={Icon}
                  activeClassName={({ isActive }) => (isActive ? 'active' : '')}
                  sx={buttonStyles}
                >
                  {label}
                </Button>
              </Stack>
            )
          })}
        </Stack>
        <SystemActions />
      </Stack>
    </Stack>
  )
}
